import { Routes } from '@angular/router';
import { LoginContainerComponent } from './containers/login/login.container';

export const AuthenticationRoutes: Routes = [
  {
    path: 'login',
    component: LoginContainerComponent,
  },
];
